import { createSlice, createAsyncThunk, current } from "@reduxjs/toolkit";
import { centralAdminUrls } from "./centralAdminUtils";
import { apiUrls } from "../../library/Utils";
import { saveAs } from "file-saver";

//centralised function for creating request options for both GET and POST methods
const getRequestOptions = (method, body = null) => {
    const data = JSON.parse(localStorage.getItem("data"));
    const token = data.token;

    return {
        method,
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
        },
        ...(body && { body: JSON.stringify(body) }),
    };
};

//Function to handle API calls and error handling
const fetchData = async (url, options) => {
    try {
        const response = await fetch(url, options);
        return await response.json();
    } catch (error) {
        console.error("Error: ", error);
        throw error;
    }
};

export const GetUserCountries = createAsyncThunk(
    "functionalAdmin/GetUserCountries",
    async ({ method }, thunkAPI) => {
        const data = JSON.parse(localStorage.getItem("data"));
        const url = apiUrls.countryListUrl + data.userID;
        const options = getRequestOptions(method);
        return fetchData(url, options);
    }
);
//Central Admin-----Approval Levels
export const SaveScenarioRoleMapping = createAsyncThunk(
    "centralAdmin/SaveScenarioRoleMapping",
    async (obj) => {
        const url =
            centralAdminUrls.saveScenarioRoleMapping + "quotaType=" + obj.quotaType;
        const options = getRequestOptions("POST", obj.transformedArray);
        return fetchData(url, options);
    }
);

//Central Admin-----Group Scenario Activity
export const UpdateGroupOrScenarioActivation = createAsyncThunk(
  "centralAdmin/UpdateGroupOrScenarioActivation",
  async (obj, thunkAPI) => {
    const {
      GroupOrScenarioID,
      GroupOrScenarioType,
      Inactive,
      Activity,
      criticalityID,
      PeriodType,
      sticktoQuota,
    } = obj;
    const url =
      centralAdminUrls.updateGroupOrScenarioActivation +
      `GroupOrScenarioID=${GroupOrScenarioID}&GroupOrScenarioType=${GroupOrScenarioType}&Inactive=${Inactive}&Activity=${Activity}&criticalityID=${criticalityID}&PeriodType=${PeriodType}&sticktoQuota=${sticktoQuota}`;
    const options = getRequestOptions("GET");
    return fetchData(url, options);
  }
);

//Central Admin-----Group Scenario Activity
export const GetGroupOrScenarioDetails = createAsyncThunk(
  "centralAdmin/GetGroupOrScenarioDetails",
  async (obj, thunkAPI) => {
    const url =
      centralAdminUrls.getGroupScenario +
      `GeoID=${obj.countryID}&GroupOrScenarioType=${obj.viewBy}`;
    const options = getRequestOptions("GET");
    return fetchData(url, options);
  }
);

//Central Admin-----Group Scenario Activity
export const ListUpdateGroupOrScenario = createAsyncThunk(
  "centralAdmin/ListUpdateGroupOrScenario",
  async (arr, { dispatch, getState }) => {
    const url = centralAdminUrls.listUpdateGroupOrScenario;
    const options = getRequestOptions("POST", arr);
    return fetchData(url, options);
  }
);

//Central Admin-----User Administartion
export const GetUsers = createAsyncThunk(
  "centralAdmin/GetUsers",
  async () => {
    const url = `${centralAdminUrls.getUsers}RoleID=0&CountryID=null&searchText=null`;
    const options = getRequestOptions("GET");
    return fetchData(url, options);
  }
);

//Central Admin-----User Administartion
export const GetRoles = createAsyncThunk(
  "centralAdmin/GetRoles",
  async ({ method }) => {
    const url = centralAdminUrls.getRoles;
    const options = getRequestOptions(method);
    return fetchData(url, options);
  }
);

//Central Admin-----User Administartion
export const UpdateAndSaveUser = createAsyncThunk(
  "centralAdmin/UpdateAndSaveUser",
  async (obj) => {
    const url = centralAdminUrls.updateAndSaveUser;
    const options = getRequestOptions("POST", obj);

    return fetchData(url, options);
  }
);

//Central Admin-----User Administartion
export const DeleteUsers = createAsyncThunk(
  "centralAdmin/DeleteUsers",
  async (selectedRowID) => {
    const url = centralAdminUrls.deleteUsers;
    const options = getRequestOptions("POST", selectedRowID);

    return fetchData(url, options);
  }
);

//Central Admin-----User Administartion
export const SaveUser = createAsyncThunk(
  "centralAdmin/SaveUser",
  async (obj) => {
    const url = centralAdminUrls.saveUser;
    const options = getRequestOptions("POST", obj);

    return fetchData(url, options);
  }
);


export const GetUOMs = createAsyncThunk(
  "ProductGroup/GetUOMCodes",
  async (obj) => {
    let reqOptions = {};
    const data = JSON.parse(localStorage.getItem("data"));
    reqOptions.method = obj.method;
    let url = apiUrls.uomListUrl;
    return fetch(url, reqOptions).then((r) => {
      return r.json();
    });
  }
);


export const GetDatasources = createAsyncThunk(
  "centralAdmin/GetDatasources",
  async (obj) => {
    let reqOptions = {};
    reqOptions.method = obj.method;
    let url = centralAdminUrls.getDatasources;
    return fetch(url, reqOptions).then((r) => {
      return r.json();
    });
  }
);
export const GetCustomerNumber = createAsyncThunk(
  "centralAdmin/GetCustomerNumber",
  async (countryId) => {
    const data = JSON.parse(localStorage.getItem("data"));
    const token = data.token;

    const url = centralAdminUrls.GetCustomerNumber + "CountryID=" + countryId;

    try {
      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      });
      const jsonData = await response.json();
      return jsonData;
    } catch (error) {
      console.error("centralAdmin/GetCustomerNumber Error: ", error);
    }
  }
);
export const GetSalesOrderNumberLineItem = createAsyncThunk(
  "centralAdmin/GetSalesOrderNumberLineItem",
  async (object, { dispatch, getState }) => {
    try {
      const data = JSON.parse(localStorage.getItem("data"));
      const token = data.token;
      const url = centralAdminUrls.GetSalesOrderNumberLineItem;
      const { selectedDataCustomerIds, selectedCountryID } =
        getState().centralAdmin;
      const { selectedSalesOrder, selectedPeriod } = object;
      let obj = {
        countryId: selectedCountryID,
        CustomerNumber: selectedDataCustomerIds.join(),
        period: selectedPeriod,
        salesOrder: "",
      };
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
        body: JSON.stringify(obj),
      });
      const jsonData = response.json();
      return jsonData;
    } catch (error) {
      console.error("centralAdmin/GetSalesOrderNumberLineItem Error", error);
    }
  }
);
export const GetLineItem = createAsyncThunk(
  "centralAdmin/GetLineItem",
  async (object, { dispatch, getState }) => {
    try {
      const data = JSON.parse(localStorage.getItem("data"));
      const token = data.token;
      const url = centralAdminUrls.GetSalesOrderNumberLineItem;
      const { selectedDataCustomerIds, selectedCountryID } =
        getState().centralAdmin;
      const { selectedSalesOrder, selectedPeriod } = object;
      let obj = {
        countryId: selectedCountryID,
        CustomerNumber: selectedDataCustomerIds.join(),
        period: selectedPeriod,
        salesOrder: selectedSalesOrder,
      };
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
        body: JSON.stringify(obj),
      });
      const jsonData = response.json();
      return jsonData;
    } catch (error) {
      console.error("centralAdmin/GetLineItem Error", error);
    }
  }
);
export const getDataSourcesRecords = createAsyncThunk(
  "centralAdmin/getDataSourcesRecords",
  async (object, { dispatch, getState }) => {
    try {
      const data = JSON.parse(localStorage.getItem("data"));
      const token = data.token;
      const url = centralAdminUrls.getDataSourcesRecords;
      const { countryID, customerNumber, period, salesOrder, lineItem } =
        object;
      let obj = {
        countryId: countryID,
        CustomerNumber: customerNumber,
        period: period,
        salesOrder: salesOrder,
        lineItemNumber: lineItem,
      };
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
        body: JSON.stringify(obj),
      });
      const jsonData = response.json();
      return jsonData;
    } catch (error) {
      console.error("centralAdmin/getDataSourcesRecords Error", error);
    }
  }
);
export const ModifyDataSourcesRows = createAsyncThunk(
  "centralAdmin/ModifyDataSourcesRows",
  async (obj) => {
    try {
      const data = JSON.parse(localStorage.getItem("data"));
      const token = data.token;
      const url = centralAdminUrls.ModifyDataSourcesRows;
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
        body: JSON.stringify(obj),
      });
      const jsonData = response.json();
      return jsonData;
    } catch (error) {
      console.error("centralAdmin/ModifyDataSourcesRows Error", error);
    }
  }
);

export const UpdateSKUSwitch = createAsyncThunk(
  "centralAdmin/UpdateSKUSwitch",
  async (obj) => {
    try {
      const data = JSON.parse(localStorage.getItem("data"));
      const token = data.token;
      const url = centralAdminUrls.updateSKUSwitch;

      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
        body: JSON.stringify(obj),
      });
      const jsonData = response.json();
      return jsonData;
    } catch (error) {
      console.error("centralAdmin/UpdateAndSaveUser Error", error);
    }
  }
);

export const UpdateUOMSKU = createAsyncThunk(
  "centralAdmin/UpdateUOMSKU",
  async (obj) => {
    try {
      const data = JSON.parse(localStorage.getItem("data"));
      const token = data.token;
      const url = centralAdminUrls.updateUOMSKU;

      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
        body: JSON.stringify(obj),
      });
      const jsonData = response.json();
      return jsonData;
    } catch (error) {
      console.error("centralAdmin/UpdateUOMSKU Error", error);
    }
  }
);

export const GetInDemandDataReport = createAsyncThunk(
  "centralAdmin/GetInDemandDataReport",
  async (obj) => {
    const data = JSON.parse(localStorage.getItem("data"));
    const token = data.token;

    const url =
      centralAdminUrls.getInDemandDataReport +
      "countryId=" +
      obj.countryId +
      "&dataSourceId=" +
      obj.dataSourceId +
      "&period=" +
      obj.period;

    try {
      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      });
      const jsonData = await response.json();
      return jsonData;
    } catch (error) {
      console.error("centralAdmin/GetInDemandDataReport Error: ", error);
    }
  }
);

export const GetSKUSwitchSearch = createAsyncThunk(
  "centralAdmin/GetSKUSwitchSearch",
  async (obj) => {
    const data = JSON.parse(localStorage.getItem("data"));
    const token = data.token;

    const url =
      centralAdminUrls.getSKUSwitchSearch +
      "CountryID=" +
      obj.countryID +
      "&ProductName=" +
      obj.productName +
      "&SKUType=1";

    try {
      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      });
      const jsonData = await response.json();
      return jsonData;
    } catch (error) {
      console.error("centralAdmin/GetSKUSwitchSearch Error: ", error);
    }
  }
);

export const GetSKUbyCountry = createAsyncThunk(
  "centralAdmin/GetSKUbyCountry",
  async (obj) => {
    const data = JSON.parse(localStorage.getItem("data"));
    const token = data.token;

    const url = centralAdminUrls.getSKUbyCountry + "CountryID=" + obj.countryID;

    try {
      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      });
      const jsonData = await response.json();
      return jsonData;
    } catch (error) {
      console.error("centralAdmin/GetSKUbyCountry Error: ", error);
    }
  }
);

export const ExportInDemandReport = createAsyncThunk(
  "analyze/ExportInDemandReport",
  async (obj, thunkAPI) => {
    const data = JSON.parse(localStorage.getItem("data"));
    const token = data.token;
    const {
      isPdf,
      AnalyzeTitle,
      CountryID,
      CountryName,
      DataSourceID,
      DataSourceName,
      Duration,
      listAnalyseData,
    } = obj;

    const url = centralAdminUrls.exportInDemandReport + `isPdf=${isPdf}`;

    const postBody = {
      AnalyzeTitle,
      CountryID,
      CountryName,
      DataSourceID,
      DataSourceName,
      Duration,
      listAnalyseData,
    };

    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
        body: JSON.stringify(postBody),
      });
      const res = await response.blob();
      const extension = isPdf ? "pdf" : "xlsx";
      const fileName = `InDemandDataReport_${CountryName}_${DataSourceName} Last ${Duration} Months.${extension}`;
      saveAs(res, fileName);
      return res;
    } catch (error) {
      console.error("Error: ", error);
    }
  }
);

export const ExportSkuReplacementData = createAsyncThunk(
  "analyze/ExportSkuReplacementData",
  async (obj, thunkAPI) => {
    const data = JSON.parse(localStorage.getItem("data"));
    const token = data.token;

    const url =
      centralAdminUrls.exportSkuReplacementData + `isPdf=${obj.isPdf}`;

    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
        body: JSON.stringify(obj.updatedSKUData),
      });
      const res = await response.blob();
      const extension = obj.isPdf ? "pdf" : "xlsx";
      const fileName = `Download.${extension}`;
      saveAs(res, fileName);
      return res;
    } catch (error) {
      console.error("Error: ", error);
    }
  }
);

export const GetFolderIdByName = createAsyncThunk(
  "centralAdmin/GetFolderIdByName",
  async (obj) => {
    const data = JSON.parse(localStorage.getItem("data"));
    const token = data.token;

    const url =
      centralAdminUrls.getFolderIdByName + "FolderName=" + obj.FolderName;

    try {
      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      });
      const jsonData = await response.json();
      return jsonData;
    } catch (error) {
      console.error("centralAdmin/GetFolderIdByName Error: ", error);
    }
  }
);

export const GetFolderContent = createAsyncThunk(
  "centralAdmin/GetFolderContent",
  async (obj) => {
    const data = JSON.parse(localStorage.getItem("data"));
    const token = data.token;

    const url = centralAdminUrls.getFolderContent + "id=" + obj.id;

    try {
      const response = await fetch(url, {
        method: obj.method,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      });
      const jsonData = await response.json();
      return jsonData.items;
    } catch (error) {
      console.error("centralAdmin/GetFolderContent Error: ", error);
    }
  }
);

export const DownloadFile = createAsyncThunk(
  "centralAdmin/DownloadFile",
  async (obj) => {
    const data = JSON.parse(localStorage.getItem("data"));
    const token = data.token;

    const url = centralAdminUrls.downloadFile + "fileId=" + obj.fileId;

    try {
      const response = await fetch(url, {
        method: obj.method,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      });

      const res = await response.blob();
      const fileName = obj.fileName;
      saveAs(res, fileName);
      return res;
    } catch (error) {
      console.error("centralAdmin/DownloadFile Error: ", error);
    }
  }
);
const initialState = {
  isLoading: false,
  isSuccess: false,
  isFailed: false,
  isSuccess_Info: "",
  isFailed_Info: "",
  isError: false,
  showOrHideExport: false,
  countries: [],
  selectedCountry: "All",
  selectedCountryID: 0,
  roles: [],
  dataSource: [],
  selectedRole: "All",
  selectedRoleID: 0,
  getUserDataInitially: [],
  getInDemandDataReport: [],
  selectedDataSource: "",
  selectedDataSourceID: null,
  selectedDurationID: null,
  selectedDurationName: "",
  getSKUData: [],
  getSKUbyCountry: [],
  getFolderIdByName: "",
  getFolderContent: [],
  apiResponse: null,
  selectedClientProductCode: [],
  selectedSKUDescription: [],
  selectedNewSku: [],
  selectedReplaceOption: [],
  getGroupScenarioData: [],
  listUpdateGS: null,
  CustomerNumberList: [],
  selectedPeriod: "",
  selectedDataSalesOrders: [],
  selectedDataCustomerIds: [],
  SalesOrderList: [],
  selectedDataLineItems: [],
  LineItemList: [],
  OrderModRecords: [],
  selectedRowIds: [],
  UOMs:[],
  SelectedUOM:"",
  isSearchClicked: false,
};

const centralAdminSlice = createSlice({
  name: "centralAdmin",
  initialState,
  reducers: {
    setState: {
      prepare(stateName, stateValue) {
        return {
          payload: { stateName, stateValue },
        };
      },
      reducer(state, action) {
        const { stateName, stateValue } = action.payload;
        state[stateName] = stateValue;
      },
    },
    reset(state, { payload }) {
      if (payload === "OnRefresh") {
        state.selectedCountry = "";
        state.selectedCountryID = null;
        state.CustomerNumberList = [];
        state.selectedPeriod = "";
        state.selectedDataSalesOrders = [];
        state.selectedDataCustomerIds = [];
        state.SalesOrderList = [];
        state.selectedDataLineItems = [];
        state.LineItemList = [];
        state.OrderModRecords = [];
        state.selectedRowIds = [];
      } else if (payload === "OnCountryChange") {
        state.CustomerNumberList = [];
        state.selectedPeriod = "";
        state.selectedDataSalesOrders = [];
        state.selectedDataCustomerIds = [];
        state.SalesOrderList = [];
        state.selectedDataLineItems = [];
        state.LineItemList = [];
        state.OrderModRecords = [];
        state.selectedRowIds = [];
      } else if (payload === "OnCustomerChange") {
        state.selectedPeriod = "";
        state.selectedDataSalesOrders = [];
        state.SalesOrderList = [];
        state.selectedDataLineItems = [];
        state.LineItemList = [];
        state.OrderModRecords = [];
        state.selectedRowIds = [];
      } else if (payload === "OnPeriodChange") {
        state.selectedDataSalesOrders = [];
        state.SalesOrderList = [];
        state.selectedDataLineItems = [];
        state.LineItemList = [];
        state.OrderModRecords = [];
        state.selectedRowIds = [];
      } else if (payload === "OnSalesOrderChange") {
        state.selectedDataLineItems = [];
        state.LineItemList = [];
        state.OrderModRecords = [];
        state.selectedRowIds = [];
      } else if (payload === "OnLineItemChange") {
        state.OrderModRecords = [];
        state.selectedRowIds = [];
      }
    },
    clearStatus(state, { payload }) {
      state.isSuccess = false;
      state.isSuccess_Info = false;
      state.isFailed = false;
      state.isFailed_Info = "";
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(GetUserCountries.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(GetUserCountries.fulfilled, (state, { payload }) => {
        state.countries = payload;
        console.log("Countries", state.countries);
        state.isLoading = false;
      })
      .addCase(GetUserCountries.rejected, (state, action) => {
        state.isLoading = false;
        console.log("Error from GetUserCountries", action.error.message);
      })

      .addCase(GetUOMs.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(GetUOMs.fulfilled, (state, { payload }) => {
        state.UOMs = payload;
        console.log("UOMs", state.UOMs);
        state.isLoading = false;
      })
      .addCase(GetUOMs.rejected, (state, action) => {
        state.isLoading = false;
        console.log("Error from GetUOMs", action.error.message);
      })
      

      .addCase(GetRoles.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(GetRoles.fulfilled, (state, { payload }) => {
        state.roles = payload;
        state.isLoading = false;
      })
      .addCase(GetRoles.rejected, (state, action) => {
        state.isLoading = false;
        console.log("Error from GetRoles", action.error.message);
      })

      .addCase(GetDatasources.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(GetDatasources.fulfilled, (state, { payload }) => {
        state.dataSource = payload;
        state.isLoading = false;
      })
      .addCase(GetDatasources.rejected, (state, action) => {
        state.isLoading = false;
        console.log("Error from GetRoles", action.error.message);
      })

      .addCase(GetUsers.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(GetUsers.fulfilled, (state, { payload }) => {
        state.getUserDataInitially = payload;
        state.isLoading = false;
      })
      .addCase(GetUsers.rejected, (state, action) => {
        state.isLoading = false;
        console.log("Error from GetUsers", action.error.message);
      })

      .addCase(UpdateAndSaveUser.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(UpdateAndSaveUser.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        if (payload == 1) {
          state.isSuccess = true;
          state.isSuccess_Info = "Record saved successfully";
        } else {
          state.isFailed = true;
          state.isFailed_Info = "Error occured in UpdateAndSaveUser";
        }
      })
      .addCase(UpdateAndSaveUser.rejected, (state, action) => {
        state.isLoading = false;
        console.error("Error from UpdateAndSaveUser", action.error.message);
      })

      .addCase(UpdateSKUSwitch.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(UpdateSKUSwitch.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        if (payload.statusCode > 0) {
          if (payload.message.length > 1) {
            state.isFailed = true;
            state.isFailed_Info =
              payload.message + " referred in multiple Scenarios";
          }
          state.isSuccess = true;
          state.isSuccess_Info = "Selected SKU(s) updated successfully";
        } else {
          state.isFailed = true;
          state.isFailed_Info =
            payload.message + " referred in multiple Scenarios";
        }
      })
      .addCase(UpdateSKUSwitch.rejected, (state, action) => {
        state.isLoading = false;
        console.error("Error from UpdateSKUSwitch", action.error.message);
      })

      .addCase(UpdateUOMSKU.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(UpdateUOMSKU.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        if (payload.statusCode > 0) {
          state.isSuccess = true;
          state.isSuccess_Info = "Selected SKU(s) updated successfully";
        }
        else{
          state.isFailed = true;
          state.isFailed_Info = "Error in updating SKU";
        }
      })
      .addCase(UpdateUOMSKU.rejected, (state, action) => {
        state.isLoading = false;
        console.error("Error from UpdateUOMSKU", action.error.message);
      })      

      .addCase(SaveUser.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(SaveUser.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        if (payload > 0) {
          state.isSuccess = true;
          state.isSuccess_Info = "Updated Record successfully";
        } else {
          state.isFailed = true;
          state.isFailed_Info = "Error occured in SaveUser";
        }
      })
      .addCase(SaveUser.rejected, (state, action) => {
        state.isLoading = false;
        console.error("Error from SaveUser", action.error.message);
      })

      .addCase(DeleteUsers.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(DeleteUsers.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        if (typeof payload !== "string") {
          state.isSuccess = true;
          state.isSuccess_Info = "Deactivated selected user(s) successfully.";
        } else {
          state.isFailed = true;
          state.isFailed_Info = "Error occured in DeleteUsers";
        }
      })
      .addCase(DeleteUsers.rejected, (state, action) => {
        state.isLoading = false;
        console.error("Error from DeleteUsers", action.error.message);
      })

      .addCase(SaveScenarioRoleMapping.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(SaveScenarioRoleMapping.fulfilled, (state, { payload }) => {
       
        if (payload == "Ok") {
          state.isSuccess = true;
          state.isSuccess_Info =
            "Scenario Criticality to Role Mapping updated successfully.";
        } else {
          state.isFailed = true;
          state.isFailed_Info = "Error occured in SaveScenarioRoleMapping";
        }
        state.isLoading = false;
      })
      .addCase(SaveScenarioRoleMapping.rejected, (state, action) => {
        state.isLoading = false;
        console.error(
          "Error from SaveScenarioRoleMapping",
          action.error.message
        );
      })

      .addCase(GetInDemandDataReport.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(GetInDemandDataReport.fulfilled, (state, { payload }) => {
        state.getInDemandDataReport = payload;
        if (payload) {
          if (payload.length > 0) {
            state.showOrHideExport = true;
          } else state.showOrHideExport = false;
        } else state.showOrHideExport = false;
        state.isLoading = false;
      })
      .addCase(GetInDemandDataReport.rejected, (state, action) => {
        state.isLoading = false;
        console.log("Error from GetInDemandDataReport", action.error.message);
      })

      .addCase(GetSKUSwitchSearch.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(GetSKUSwitchSearch.fulfilled, (state, { payload }) => {
        state.getSKUData = payload;
        if (payload) {
          if (payload.length > 0) {
            state.showOrHideExport = true;
          } else state.showOrHideExport = false;
        } else state.showOrHideExport = false;
        state.isLoading = false;
      })
      .addCase(GetSKUSwitchSearch.rejected, (state, action) => {
        state.isLoading = false;
        console.log("Error from GetSKUSwitchSearch", action.error.message);
      })

      .addCase(GetSKUbyCountry.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(GetSKUbyCountry.fulfilled, (state, { payload }) => {
        state.getSKUbyCountry = payload;
        state.isLoading = false;
      })
      .addCase(GetSKUbyCountry.rejected, (state, action) => {
        state.isLoading = false;
        console.log("Error from GetSKUbyCountry", action.error.message);
      })

      .addCase(GetFolderIdByName.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(GetFolderIdByName.fulfilled, (state, { payload }) => {
        state.getFolderIdByName = payload;
        state.isLoading = false;
      })
      .addCase(GetFolderIdByName.rejected, (state, action) => {
        state.isLoading = false;
        console.log("Error from GetFolderIdByName", action.error.message);
      })

      .addCase(GetFolderContent.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(GetFolderContent.fulfilled, (state, { payload }) => {
        state.getFolderContent = payload;
        state.isLoading = false;
      })
      .addCase(GetFolderContent.rejected, (state, action) => {
        state.isLoading = false;
        console.log("Error from GetFolderContent", action.error.message);
      })

      .addCase(DownloadFile.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(DownloadFile.fulfilled, (state, action) => {
        state.apiResponse = action.payload;
        state.isLoading = false;
      })
      .addCase(DownloadFile.rejected, (state, action) => {
        state.isLoading = false;
        console.log("Error from DownloadFile", action.error.message);
      })

      .addCase(ExportInDemandReport.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(ExportInDemandReport.fulfilled, (state, action) => {
        state.apiResponse = action.payload;
        state.isLoading = false;
      })
      .addCase(ExportInDemandReport.rejected, (state, action) => {
        state.isLoading = false;
        console.error("Error from ExportInDemandReport", action.error.message);
      })

      .addCase(ExportSkuReplacementData.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(ExportSkuReplacementData.fulfilled, (state, action) => {
        state.apiResponse = action.payload;
        state.isLoading = false;
      })
      .addCase(ExportSkuReplacementData.rejected, (state, action) => {
        state.isLoading = false;
        console.error(
          "Error from ExportSkuReplacementData",
          action.error.message
        );
      })

      .addCase(GetGroupOrScenarioDetails.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(GetGroupOrScenarioDetails.fulfilled, (state, { payload }) => {
        state.getGroupScenarioData = payload;
        state.isLoading = false;
      })
      .addCase(GetGroupOrScenarioDetails.rejected, (state, action) => {
        state.isLoading = false;
        console.log(
          "Error from GetGroupOrScenarioDetails",
          action.error.message
        );
      })
      .addCase(ListUpdateGroupOrScenario.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(ListUpdateGroupOrScenario.fulfilled, (state, { payload }) => {
        state.listUpdateGS = payload;
        state.isLoading = false;

        if (payload != 0) {
          state.isSuccess = true;
          state.isSuccess_Info = "Saved Successfully!";
        } else {
          state.isFailed = true;
          state.isFailed_Info = "No changes to save";
        }
      })
      .addCase(ListUpdateGroupOrScenario.rejected, (state, action) => {
        state.isLoading = false;
        console.log(
          "Error from ListUpdateGroupOrScenario",
          action.error.message
        );
      })
      .addCase(GetCustomerNumber.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(GetCustomerNumber.fulfilled, (state, { payload }) => {
        state.CustomerNumberList = payload;
        state.isLoading = false;
        state.CustomerNumberList = Array.from(
          new Set(state.CustomerNumberList.map((s) => s.customerNumber))
        ).map((customerNumber) => {
          return { customerNumber: customerNumber, id: customerNumber };
        });

        if (state.CustomerNumberList.length == 0) {
          state.isFailed = true;
          state.isFailed_Info =
            "No Customers with Reviewed Status in the selected Country.";
        }
      })
      .addCase(GetCustomerNumber.rejected, (state, action) => {
        state.isLoading = false;
        console.log("Error from GetCustomerNumber", action.error.message);
      })
      .addCase(GetSalesOrderNumberLineItem.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(GetSalesOrderNumberLineItem.fulfilled, (state, { payload }) => {
        state.SalesOrderList = payload;
        state.isLoading = false;
        state.SalesOrderList = Array.from(
          new Set(state.SalesOrderList.map((s) => s.salesOrder))
        ).map((salesOrder) => {
          return { salesOrder: salesOrder, id: salesOrder };
        });
        if (state.SalesOrderList.length == 0) {
          state.isFailed = true;
          state.isFailed_Info = "No sales order present for this combination.";
        }
      })
      .addCase(GetSalesOrderNumberLineItem.rejected, (state, action) => {
        state.isLoading = false;
        console.log(
          "Error from GetSalesOrderNumberLineItem",
          action.error.message
        );
      })
      .addCase(GetLineItem.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(GetLineItem.fulfilled, (state, { payload }) => {
        state.LineItemList = payload;
        state.isLoading = false;
        state.LineItemList = Array.from(
          new Set(state.LineItemList.map((s) => s.lineItemNo))
        ).map((lineItemNo) => {
          return { lineItemNo: lineItemNo, id: lineItemNo };
        });

        if (state.LineItemList.length == 0) {
          state.isFailed = true;
          state.isFailed_Info = "No Line Item present for this combination.";
        }
      })
      .addCase(GetLineItem.rejected, (state, action) => {
        state.isLoading = false;
        console.log("Error from GetLineItem", action.error.message);
      })
      .addCase(getDataSourcesRecords.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(getDataSourcesRecords.fulfilled, (state, { payload }) => {
        state.OrderModRecords = payload;
        state.isLoading = false;
        // state.SalesOrderList=Array.from(new Set(state.SalesOrderList.map(s=>s.salesOrder))).map(salesOrder=>{return {salesOrder:salesOrder,id:salesOrder};});

        // if(state.OrderModRecords.length==0){
        //   state.isFailed = true;
        //   state.isFailed_Info = "No records present for this combination.";
        // }
      })
      .addCase(getDataSourcesRecords.rejected, (state, action) => {
        state.isLoading = false;
        console.log("Error from getDataSourcesRecords", action.error.message);
      })
      .addCase(ModifyDataSourcesRows.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(ModifyDataSourcesRows.fulfilled, (state, { payload }) => {
        state.isLoading = false;

        if (state.selectedRowIds.length === payload) {
          state.isSuccess = true;
          state.isSuccess_Info = "Modified " + payload + " selected record(s).";
        } else {
          state.isFailed = true;
          state.isFailed_Info =
            "Not all the selected record(s) were successfully modified.";
        }
        state.selectedRowIds = [];
      })
      .addCase(ModifyDataSourcesRows.rejected, (state, action) => {
        state.isLoading = false;
        console.log("Error from ModifyDataSourcesRows", action.error.message);
      });
  },
});

export const { setState, clearStatus, reset } = centralAdminSlice.actions;

export default centralAdminSlice.reducer;
